import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/api.js';

function crudHooks(resource) {
  const listKey = [resource];

  const useList = (params = {}) =>
    useQuery({
      queryKey: [resource, params],
      queryFn: () => api.get(`/masters/${resource}`, { params }).then((r) => r.data.data),
    });

  const useCreate = () => {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: (data) => api.post(`/masters/${resource}`, data).then((r) => r.data.data),
      onSuccess: () => qc.invalidateQueries({ queryKey: listKey }),
    });
  };

  const useUpdate = () => {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: ({ id, ...data }) => api.put(`/masters/${resource}/${id}`, data).then((r) => r.data.data),
      onSuccess: () => qc.invalidateQueries({ queryKey: listKey }),
    });
  };

  const useDelete = () => {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: (id) => api.delete(`/masters/${resource}/${id}`).then((r) => r.data),
      onSuccess: () => qc.invalidateQueries({ queryKey: listKey }),
    });
  };

  return { useList, useCreate, useUpdate, useDelete };
}

export const locationHooks        = crudHooks('locations');
export const meHooks              = crudHooks('merchant-exporters');
export const ppcHooks             = crudHooks('ppcs');
export const productHooks         = crudHooks('products');
export const userHooks            = crudHooks('users');
export const customerHooks        = crudHooks('customers');
export const portHooks            = crudHooks('ports');
export const supplierHooks        = crudHooks('suppliers');
export const purchaseCenterHooks  = crudHooks('purchase-centers');
export const fCodeHooks           = crudHooks('fcodes');

export const useThresholds = () =>
  useQuery({ queryKey: ['approval-thresholds'], queryFn: () => api.get('/masters/approval-thresholds').then(r => r.data.data) });

export const useUpsertThreshold = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/masters/approval-thresholds', data).then(r => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['approval-thresholds'] }),
  });
};

export const useNotifSettings = () =>
  useQuery({ queryKey: ['notification-settings'], queryFn: () => api.get('/masters/notification-settings').then(r => r.data.data) });

export const useUpdateNotifSettings = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.put('/masters/notification-settings', data).then(r => r.data.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-settings'] }),
  });
};
